import { Box, Typography } from '@mui/material';
import React from 'react';
import { PageTitle } from '../../../components/PageTitle';
import { Button } from '../../../components/Button/Button';
import { IconPlus } from '../../../utils/icons';

interface Props {
  onCreate?: () => void;
}

export function Header({ onCreate }: Props) {
  return (
    <Box>
      <Box className="w-full flex flex-wrap justify-between items-center gap-3 pb-8">
        <PageTitle title="categories" />
        <Box className="flex gap-4">
          <Button className="!flex gap-2 !px-4" onClick={onCreate}>
            <IconPlus />
            <Typography>New Category</Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
